import * as angular from 'angular';

/* @ngInject */
export const feedbackSettings = function (WebStorage) {
	const storage = new WebStorage('feedbackSettings');

	return {
		autoPlay: angular.isDefined(storage.get('autoPlay')) ? storage.get('autoPlay') : true,
		oneClickMarker: angular.isDefined(storage.get('oneClickMarker')) ? storage.get('oneClickMarker') : false,

		/**
		 * Toggle media comment auto play
		 *
		 * @param value
		 * @param persist
		 */
		toggleAutoPlay (value, persist) {
			if (angular.isUndefined(value)) {
				value = !this.autoPlay;
			}
			this.autoPlay = value;

			// auto persist
			if (angular.isUndefined(persist)) {
				persist = true;
			}

			if (persist) {
				// store feedback setting
				storage.put('autoPlay', value);
			}
		},

		/**
		 * Toggle one-click marker setting
		 *
		 * @param value
		 */
		 toggleOneClickMarker (value) {
			this.oneClickMarker = !!value;
			storage.put('oneClickMarker', value);
		}
	};
};
